module.exports = __webpack_public_path__ + "static/media/mainbrain.54427670.png";